export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Elektronische Gästemeldung für die Polizia di Stato (Italien)",

  fields: {
    utente: "Utente",
    password: "Passwort",
    wskey: "WsKey",
    wskeyHint: "Der WsKey wird im Portal alloggiatiweb.poliziadistato.it unter „Gestione dispositivi“ erzeugt.",
    tipoStruttura: "Unterkunftsart",
    idAppartamento: "Wohnungs-ID",
    idAppartamentoHint: "In Alloggiati Web registrierte Wohnungs-ID.",
    keepBlank: "(leer lassen, um den aktuellen Wert zu behalten)",
  },

  tipoOptions: {
    hotel: "Hotel / B&B / Ferienwohnung",
    appartamento: "Verwaltete Wohnung",
  },

  actions: {
    saveAndVerify: "Speichern & prüfen",
    updateCredentials: "Zugangsdaten aktualisieren",
    verifyConnection: "Verbindung prüfen",
    saving: "Wird gespeichert...",
    verifying: "Wird geprüft...",
  },

  status: {
    connectionOk: "Zugangsdaten gespeichert und Verbindung erfolgreich geprüft.",
    connectionError: "Verbindungsfehler. Bitte prüfen Sie die eingegebenen Zugangsdaten.",
    connectionPending: "Verbindung noch nicht geprüft. Klicken Sie auf \"Verbindung prüfen\", um sie zu bestätigen.",
  },

  validation: {
    utenteRequired: "Das Feld Utente ist erforderlich.",
    passwordRequired: "Passwort ist erforderlich.",
    wskeyRequired: "WsKey ist erforderlich.",
    idAppartamentoRequired: "Die Wohnungs-ID ist erforderlich.",
  },

  toasts: {
    saveSuccess: "Zugangsdaten gespeichert und Verbindung erfolgreich geprüft.",
    saveWarning: "Zugangsdaten gespeichert, die Verbindung konnte jedoch nicht geprüft werden.",
    saveError: "Zugangsdaten konnten nicht gespeichert werden.",
    testSuccess: "Verbindung zu Alloggiati Web erfolgreich geprüft.",
    testError: "Die Verbindung konnte nicht geprüft werden.",
    statusActive: "Alloggiati Web aktiviert.",
    statusInactive: "Alloggiati Web deaktiviert.",
  },
};
